/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { CmsConfig } from "../../config.js";

const StageGuard = (props) => {

    const children = props?.children;
    const isStage = CmsConfig.isStage;
    const isPreview = CmsConfig.isPreview;

    if (!isStage) {
        return null;
    }
    if (isPreview) {
        return null;
    }
    return (
        <>{children}</>
    );
};

export { StageGuard };
